import { MemreLayout, MemreFlexBox, MemreLoading, MemreText } from 'components/core';
import * as Color from 'core/colors';
import { useAllCoursesKnowledgeBank } from 'hooks/useAllCoursesKnowledgeBank';
import KnowledgeBankVisWithData from './KnowledgeBankVisWithData';

export default function AllCoursesKnowledgeBank() {
  const { data, isLoading } = useAllCoursesKnowledgeBank();

  return (
    <MemreLayout headerText="My Courses Knowledge Bank" backLink="/nav/v4/dashboard" isLoading={isLoading}>
      <MemreFlexBox direction="column">
        {isLoading ? (
          <MemreFlexBox direction="column" align="center" justify="center" gap={2} sx={{ p: 3 }}>
            <MemreLoading /> <MemreText sx={{ color: Color.darkGray }}>Loading Courses</MemreText>
          </MemreFlexBox>
        ) : (
          <KnowledgeBankVisWithData data={data} isCoursesView={true} />
        )}
      </MemreFlexBox>
    </MemreLayout>
  );
}
